// extracted by mini-css-extract-plugin
export default {"cbx":"Checkbox_cbx__+oHSr","inp-cbx":"Checkbox_inp-cbx__+iEE-","wave":"Checkbox_wave__-Qiuh"};